import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import routes from '../routes/route';
import tableSportRoomContentsVT from './tableSportRoomContentsVT';

export default {
  attributeName: 'appProvider',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  editURL: routes.APP_PROVIDER_EDIT,
  emptyMessage: "You don't have V.T. Providers, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'providerImage',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Logo to identify the provider in the app.',
      placeholder: 'Poster URL...',
      exactWidth:'200px',
      canCreate: true,
      canEdit: true,
      fileType:['image/*']
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Title of virtual ticket provider.',
      default: '',
      width: '15rem',
      exactWidth:'300px',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'uses',
      label: 'Uses',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      helpText: 'Number of uses per token.',
      default: 1,
      exactWidth:'120px',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: false,
    },
    {
      attributeName: 'description',
      label: 'Description',
      type: FormInputTypes.TEXT_EDITOR,
      canEdit: true,
      canCreate: true,
      default: '',
      helpText: 'Description of the provider to info the user when he/she goes to buy a ticket.',
      canFilter: false,
      canOrder: false,
    },
    {
      attributeName: 'errorMessage',
      label: 'Error Message',
      type: FormInputTypes.TEXT_EDITOR,
      canEdit: true,
      canCreate: true,
      default: '',
      helpText: 'Error message of the provider to info the user when he/she can not redeem a ticket.',
      canFilter: false,
      canOrder: false,
    },
    {
      attributeName: 'id',
      label: 'Cont',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.LINK,
      // width: '4rem',
      exactWidth:'80px',
      small:true,
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Contents of this VT',
      openUrl:'appContentSportRoomVT',
      formConfig:
      {
        title: 'Contents from this VT',
        description:'Contents having this virtual provider',
        attributeName: 'tableContents',
        fields: [
          {
            attributeName: 'SportRoomsContent',
            type: FormInputTypes.TABLE,
            label: '',
            helpText: '',
            configFile: tableSportRoomContentsVT,
          },
        ]
      },
    },   
  ],
};
